import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import GasVendorRegistry from './GasVendorRegistry';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GasVendorRegistry />
  </React.StrictMode>
);